import React, { useState } from "react";
import { Checkbox, TextField, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import { Stack } from "@mui/system";

const DataTable = ({
  rows,
  isLoading,
  onRowSelect,
  selectedRows = [],
  onAmountChange,
}) => {
  const headers = ["Ref", "Date", "Must Pay", "Amount", "Pay"];

  const [editingRowKey, setEditingRowKey] = useState(null);
  const [editValue, setEditValue] = useState("");

  const getRowKey = (row) => row.id ?? row.ref;

  const isRowSelected = (row) => {
    const key = getRowKey(row);
    return selectedRows.some((r) => getRowKey(r) === key);
  };

  const handleCheckboxChange = (row) => {
    const key = getRowKey(row);
    if (isRowSelected(row)) {
      onRowSelect(selectedRows.filter((r) => getRowKey(r) !== key));
    } else {
      onRowSelect([...selectedRows, row]);
    }
  };

  const startEdit = (row) => {
    setEditingRowKey(getRowKey(row));
    setEditValue(row.amount);
  };
  const cancelEdit = () => {
    setEditingRowKey(null);
    setEditValue("");
  };
  const saveEdit = (row) => {
    onAmountChange(row, editValue);
    cancelEdit();
  };

  return (
    <div className="table-wrapper responsive-table">
      <table className="table table-striped mt-4" id="data-table">
        <thead id="data-table-head">
          <tr>
            {headers.map((header, idx) => (
              <th key={idx}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody id="data-table-body">
          {rows?.map((row, idx) => {
            const key = getRowKey(row);
            return (
              <tr key={idx}>
                <td>{key}</td>
                <td>{row.date}</td>
                <td>{row.must_paid}</td>
                <td>
                  {editingRowKey === key ? (
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <TextField
                        type="number"
                        size="small"
                        value={editValue}
                        disabled={isLoading}
                        onChange={(e) => setEditValue(e.target.value)}
                        sx={{ width: 100, marginRight: 1 }}
                      />
                      <IconButton
                        size="small"
                        disabled={isLoading}
                        onClick={() => saveEdit(row)}
                      >
                        <SaveIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        size="small"
                        disabled={isLoading}
                        onClick={cancelEdit}
                      >
                        <CancelIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                  ) : (
                    <>
                      <span style={{ marginRight: 4 }}>{row.amount}</span>
                      {!!onAmountChange && (
                        <IconButton
                          size="small"
                          disabled={isLoading}
                          onClick={() => startEdit(row)}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      )}
                    </>
                  )}
                </td>
                <td>
                  <Checkbox
                    color="success"
                    sx={{ padding: 0 }}
                    disabled={isLoading}
                    onChange={() => handleCheckboxChange(row)}
                    checked={isRowSelected(row)}
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
